import React, { Component } from 'react';

class BalanceList extends Component {
  constructor() {
    super();
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header />
          <main>
            <table className="dsr" data-name="Balance List">
              <tbody>
                {summary.map((item, i) => (
                  <tr key={i}>
                    <td>{item.opening_date} :</td>
                    <td>
                      {new Intl.NumberFormat('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                      }).format(item.opening_balance_on_date.toFixed(2) || 0)}
                    </td>
                    <td>{item.closing_date} : </td>
                    <td>
                      {new Intl.NumberFormat('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                      }).format(item.closing_balance_on_date.toFixed(2) || 0)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
export default BalanceList;
